export default __webpack_public_path__ + "static/controladoria1-72776bc3bb5804e52561c8f532eec276.jpeg";